module.exports = __webpack_public_path__ + "static/media/10_CORTINAO_SEM_BOJO_LISO_01.c2e71a13.jpg";